export const BEST_SELLER_VALIDATION = {
    desktop_background_url: {
        required: 'Background desktop wajib diisi',
    },
    mobile_background_url: {
        required: 'Background mobile wajib diisi',
    },
    title: {
        required: 'Title wajib diisi',
    },
    product_ids: {
        required: 'Product list wajib diisi',
    },
}
